import React, { FC, useState } from "react";
import {
    Row,
    Spacer,
    Text,
    Card,
    Column,
} from "@components/1-atoms";
import { Button, ListItem } from "@components/2-molecules";
import { PlaidButton } from '@lib/plaid';

import { NavigationProp } from "@react-navigation/native";
import { css } from "@emotion/native";
import setTheme from '@lib/theme';

import * as utils from '@lib/utils';
import Pane from "@components/1-atoms/Pane";

const theme = setTheme('light');

type Props = {
    currency: string;
    data?: Array<Object>;
    navigation: NavigationProp<any>;
};

const PlaidManage: FC<Props> = ({ data, currency }) => {

    // TODO:
    // Notes: Soft-deleted institution items will not be returned
    const unlinkPlaidLink = () => { };

    return (
        <Card title="Linked account(s)">

            {
                data?.map((item: any,) => {
                    const itemId = item.id;
                    const updatedDistance = `Updated ${utils.dateDistance(item?.updatedAt)}`;
                    const error = item?.data?.error?.error_code ? `⚠️ ${item?.data?.error?.error_code}` : null;

                    return (
                        <Pane inset key={itemId}>
                            <Row>
                                <Column>
                                    <Text large style={{ alignContent: 'center' }}>{item?.institutionName}</Text>
                                    <Spacer h={.6} />
                                    <Text xsmall bold style={{ alignContent: 'center' }} color={"#808080"}>{updatedDistance}</Text>
                                </Column>
                            </Row>

                            <Row style={css`justify-content: flex-start;`}>
                                <PlaidButton
                                    itemId={itemId}
                                    fullwidth={false}
                                    color={theme.pallete.accentColor}
                                    bg={"transparent"}
                                >
                                    Update
                                </PlaidButton>
                                {/* <Spacer w={1} />
                                <Button fullwidth={false} color={theme.pallete.accentColor} bg={"transparent"} onPress={unlinkPlaidLink}>Unlink</Button> */}
                            </Row>

                            {
                                error ?

                                    <Row>
                                        <Text xsmall bold style={{ alignContent: 'center' }} color={"#ffcf0b"}>{error}</Text>
                                    </Row>
                                    :
                                    null
                            }

                            <Row>
                                {
                                    item?.feedAccounts?.map(({ id, name, description, data }: any,) => {

                                        const right = <Text currency={currency}>{data?.balances.available}</Text>;

                                        return (
                                            <ListItem inset sub={description} right={right} key={id}>
                                                {name}
                                            </ListItem>);
                                    })
                                }
                            </Row>
                            <Spacer h={2} />
                        </Pane>
                    );
                })
            }


            <Row>
                <PlaidButton inset outlined>SYNC ANOTHER ACCOUNT</PlaidButton>
            </Row>

        </Card>
    );
};

export default PlaidManage;